export default __webpack_public_path__ + "static/ai-marketing-8--mobile-d4841d92993665c26f699ae8a39410d3.webp";